module.exports = __webpack_public_path__ + "static/img/gq4498cde.png";